export default __webpack_public_path__ + "static/media/11.2.4c42ad57.jpg";